var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2259_8240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 -0.00830078C5.37616 -0.00830078 0.00390625 5.36395 0.00390625 11.9917C0.00390625 18.6187 5.37616 23.9917 12.0039 23.9917C18.6317 23.9917 24.0039 18.6187 24.0039 11.9917C24.0039 5.3647 18.6317 -0.00830078 12.0039 -0.00830078Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2244 17.1989V12.5962C18.2244 10.1302 16.9081 8.98265 15.1524 8.98265C13.7356 8.98265 13.1011 9.7619 12.7479 10.3087V9.1709H10.0794C10.1146 9.92465 10.0794 17.1989 10.0794 17.1989H12.7479V12.7154C12.7479 12.4762 12.7651 12.2362 12.8356 12.0652C13.0284 11.5859 13.4671 11.0894 14.2044 11.0894C15.1704 11.0894 15.5566 11.8252 15.5566 12.9044V17.1997L18.2244 17.1989ZM7.26763 8.07515C8.19763 8.07515 8.77738 7.4579 8.77738 6.68765C8.76013 5.90015 8.19763 5.3009 7.28488 5.3009C6.37213 5.3009 5.77588 5.8994 5.77588 6.6869C5.77588 7.4579 6.35488 8.0744 7.25113 8.0744H7.26763V8.07515ZM8.60188 17.1989V9.1709H5.93413V17.1989H8.60188Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2259_8240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.3e0cbe5d6bab9142d9a4fb6d3364a001.svg";
export { ForwardRef as ReactComponent };